module.exports = __webpack_public_path__ + "static/portfolio-image-y-f9b278605a1148522d07db14380a6aa7.jpg";